import {store} from '../store/store';

export default {
  data: function () {
    return {
      window: {
        width: 0,
        height: 0,
        scale: 0
      },
      cv: {
        height: 0
      }
    };
  },
  mounted(){
    this.resizeCv();
  },
  updated() {
    this.getCvHeight();
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    window.addEventListener("orientationchange", ()=> {
      this.handleResize(true);
    }, false);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    resizeCv() {
      var waitInterval = setInterval(() => {
        if (this.$refs.cvCraft !== undefined) {
          clearInterval(waitInterval);
          if (this.window.width < 900) {
            var $scale = (this.window.width - 30) / 870;
            this.scale = $scale;
            this.$refs.cvCraft.style.transform = "scale(" + $scale + ")";

            store.commit("testValue", 200 + ' -- ' + new Date().getTime());
          } else {
            this.$refs.cvCraft.style.transform = "scale(1)";

            store.commit("testValue", 400 + ' -- ' + new Date().getTime());
          }
        }
      }, 100);
    },
    handleResize(rotate = false) {
      if(rotate){
        this.window.width = window.outerWidth;
        this.window.height = window.outerHeight;
      }else{
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      }

      this.resizeCv();
      this.getCvHeight();
    },
    getCvHeight(){
      var waitInterval2 = setInterval(() => {
        if (document.querySelector(".cv_craft")) {
          clearInterval(waitInterval2);
          document.querySelector(".button_download_icon").style.marginTop = parseInt(document.querySelector(".cv_craft").offsetHeight * this.scale) + 40 + "px";
        }
      }, 100);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/js/mixins/cv-resize.js